export default "/images/vendor/flag-icon-css/flags/1x1/jo.svg?6fe6e076d9928ca834ffea44c382ed60";